import React from "react";
import { STAGES, stageIndex } from "@/lib/stages";

export default function PipelineTimeline({ stage, testid = "pipeline-timeline" }) {
  const current = stageIndex(stage);
  return (
    <ol className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-0 border border-line bg-parchment" data-testid={testid}>
      {STAGES.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li
            key={s.key}
            className={`p-4 border-r last:border-r-0 border-line relative ${
              active ? "bg-oxblood text-parchment" : done ? "bg-parchment2" : "bg-parchment"
            }`}
            data-testid={`pipeline-step-${s.key}`}
            data-active={active ? "1" : "0"}
          >
            <div className={`font-mono text-[10px] tracking-widest ${active ? "text-brass" : "text-sub"}`}>
              {String(i + 1).padStart(2, "0")}
            </div>
            <div className={`h-serif text-lg mt-1 ${active ? "text-parchment" : done ? "text-ink" : "text-sub"}`}>
              {s.label}
            </div>
            <div className={`text-[10px] mt-1 ${active ? "text-brass" : done ? "text-success" : "text-sub"}`}>
              {active ? "● in progress" : done ? "✓ complete" : "— pending"}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
